import { render } from "./NewCheckButton.vue?vue&type=template&id=c62f0126&scoped=true"
import script from "./NewCheckButton.vue?vue&type=script&lang=js"
export * from "./NewCheckButton.vue?vue&type=script&lang=js"

import "./NewCheckButton.vue?vue&type=style&index=0&id=c62f0126&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62f0126"]])

export default __exports__